import React, {useState, useEffect, useRef} from 'react'
import '../../assets/style/main.css'
import './style.scss'
import COVER_IMG from '../../assets/images/cover/regis-overview.png'
import CHECKED_ICON from '../../assets/images/icons/checked.png'
import { Base_API } from '../../_actions/matcher'
import { EncryptedText } from '../../utils/Encryption'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import SignIn_Navbar from '../../components/SignIn_Navbar'

function SignIn_Overview() {
    let onceMount = useRef(true);

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    }, [])

    const pageInit = async() => {
        await checkCurrentURL();   
        isPageLoading(false);
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    const onSubmit = () => {
        location.href = `${Base_API.pathWeb}/n-health/signin/policy`;
    }

    return (
        <div className='sgn-ovrw-con'>
            <img className='cover' src={COVER_IMG} />

            <h2 className='title'>ขั้นตอนการลงทะเบียน เพื่อเชื่อมต่อระบบ N Health</h2>
            <ul>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>ลงทะเบียนเลือกถ่ายรูปบัตรประชาชน หรือ ถ่ายรูปพาสปอร์ต</p>
                </li>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>กรุณาตรวจสอบข้อมูล และกรอกข้อมูลให้ครบถ้วน</p>
                </li>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>ตรวจสอบเพื่อยืนยัน OTP</p>
                </li>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>ตรวจสอบและเชื่อมต่อระบบสำเร็จ</p>
                </li>
            </ul>
            <div className="submit">
                <button onClick={onSubmit}>
                    สมัครและเชื่อมต่อระบบ
                </button>
            </div>

            <PageLoader />
            <SignIn_Navbar canClose={false}/>
        </div>
    )
}

export default SignIn_Overview